import AppService from '@/services/app.service'
import $filters from "@/modules/fptai/filters/filters";
import AgentActionTypes from "@/store/modules/agent/agent.type";
import AgentService from "@/services/agent.service";

const types = AgentActionTypes

const state = {
    agent: null, dictionary: {
        id: '', value: []
    }, fs_setting: {
        id: '', value: []
    }, variable: {
        id: '', value: []
    }, quick_reaction: {
        id: '', value: {}
    }, fallback: {
        id: '', value: {}
    }, init_cards: {
        id: '', value: []
    }, end_cards: {
        id: '', value: []
    }, interrupt: {
        id: '', value: {}
    }
}

const mutations = {
    [types.UPDATE_AGENT]: (state, agent) => {
        state.agent = agent
    }, [types.SET_SETTING]: (state, {setting, model}) => {
        state[setting] = model
    }, [types.UPDATE_FS_SETTING]: (state, model) => {
        state.fs_setting = model
    }, [types.UPDATE_QUICK_REACTION]: (state, model) => {
        state.quick_reaction = model
    }, [types.UPDATE_VARIABLE]: (state, model) => {
        state.variable = model
    }, [types.UPDATE_DICTIONARY]: (state, model) => {
        state.dictionary = model
    }, [types.UPDATE_FALLBACK]: (state, model) => {
        state.fallback = model
    }, [types.UPDATE_INIT_CARDS]: (state, model) => {
        state.init_cards = model
    }, [types.UPDATE_END_CARDS]: (state, model) => {
        state.end_cards = model
    }, [types.UPDATE_INTERRUPT]: (state, model) => {
        state.interrupt = model
    },
}

const actions = {
    [types.SET_AGENT]({commit}, data) {
        return new Promise(resolve => {
            commit(types.UPDATE_AGENT, data)
            resolve()
        })
    }, [types.UPDATE_AGENT]({commit}, {agent, model}) {
        return new Promise((resolve, reject) => {
            if (!agent && !model) {
                commit(types.UPDATE_AGENT, null)
                reject()
            }

            let promise = AgentService.CRUD.update(agent.id, model)
            const action = $filters.tc('update')
            promise.then(result => {
                commit(types.UPDATE_AGENT, result.data)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('tova')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_AGENT, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('tova')
                }))
                reject(err)
            })
        })
    }, [types.SET_SETTING]({commit}, data) {
        return new Promise(resolve => {
            state.fs_setting = {
                id: '', value: []
            }
            state.variable = {
                id: '', value: []
            }
            state.dictionary = {
                id: '', value: []
            }
            state.quick_reaction = {
                id: '', value: {}
            }
            state.fallback = {
                id: '', value: {}
            }
            state.init_cards = {
                id: '', value: []
            }
            state.end_cards = {
                id: '', value: []
            }
            data.forEach((setting) => {
                let model = {
                    id: setting['id'], value: setting['value']
                }
                commit(types.SET_SETTING, {setting: setting['key'], model: model})
            })
            resolve()
        })
    }, [types.GET_FS_SETTING]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_FS_SETTING, model)
        })
    }, [types.UPDATE_FS_SETTING]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }
            let promise
            let action
            if (!id) {
                model.key = "fs_setting"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_FS_SETTING, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('freeSwitchSetting')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_FS_SETTING, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('freeSwitchSetting')
                }))
                reject(err)
            })
        })
    }, [types.GET_QUICK_REACTION]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_QUICK_REACTION, model)
        })
    }, [types.UPDATE_QUICK_REACTION]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }

            let promise
            let action
            if (!id) {
                model.key = "quick_reaction"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_QUICK_REACTION, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('quickReaction.quickReaction')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_QUICK_REACTION, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('quickReaction.quickReaction')
                }))
                reject(err)
            })
        })
    }, [types.GET_VARIABLE]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_VARIABLE, model)
        })
    }, [types.UPDATE_VARIABLE]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }

            let promise
            let action
            if (!id) {
                model.key = "variable"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_VARIABLE, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('variable')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_VARIABLE, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('variable')
                }))
                reject(err)
            })
        })
    }, [types.GET_DICTIONARY]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_DICTIONARY, model)
        })
    }, [types.UPDATE_DICTIONARY]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }
            let promise
            let action
            if (!id) {
                model.key = "dictionary"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_DICTIONARY, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('dictionary')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_DICTIONARY, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('dictionary')
                }))
                reject(err)
            })
        })
    }, [types.GET_FALLBACK]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_FALLBACK, model)
        })
    }, [types.UPDATE_FALLBACK]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }
            let promise
            let action
            if (!id) {
                model.key = "fallback"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_FALLBACK, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('fallback')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_FALLBACK, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('fallback')
                }))
                reject(err)
            })
        })
    }, [types.GET_INIT_CARDS]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_INIT_CARDS, model)
        })
    }, [types.UPDATE_INIT_CARDS]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }
            let promise
            let action
            if (!id) {
                model.key = "init_cards"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_INIT_CARDS, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('card')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_INIT_CARDS, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('card')
                }))
                reject(err)
            })
        })
    }, [types.GET_END_CARDS]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_END_CARDS, model)
        })
    }, [types.UPDATE_END_CARDS]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }
            let promise
            let action
            if (!id) {
                model.key = "end_cards"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_END_CARDS, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('card')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_END_CARDS, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('card')
                }))
                reject(err)
            })
        })
    }, [types.GET_INTERRUPT]({commit}, payload) {
        let agentId = window.vueapp.$route.params.agentId
        return AgentService.SettingService.read(agentId, payload).then(result => {
            let data = result.data
            let model = {
                id: data.id, value: data.value
            }
            commit(types.UPDATE_INTERRUPT, model)
        })
    }, [types.UPDATE_INTERRUPT]({commit}, {id, value}) {
        return new Promise((resolve, reject) => {
            let agentId = window.vueapp.$route.params.agentId
            let model = {
                value: value
            }
            let promise
            let action
            if (!id) {
                model.key = "interrupt"
                model.tova_agent = agentId
                promise = AgentService.SettingService.create(agentId, model)
                action = $filters.tc('create')
            } else {
                promise = AgentService.SettingService.update(agentId, id, model)
                action = $filters.tc('update')
            }

            promise.then(result => {
                let model = {
                    id: result.data.id, value: result.data.value,
                }
                commit(types.UPDATE_INTERRUPT, model)
                AppService.toastSuccess($filters.tc('actionSuccessful', {
                    action, item: window.vueapp.$t('interrupt')
                }))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_INTERRUPT, false)
                AppService.handleRequestError($filters.tc('actionFailed', {
                    action, item: window.vueapp.$t('interrupt')
                }))
                reject(err)
            })
        })
    },
}

export default {
    namespaced: true, state, mutations, actions
}
